var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"b-aside"},[_c('ul',{staticClass:"b-aside__nav"},[_c('li',{staticClass:"b-aside__nav-item"},[_c('button',{staticClass:"b-aside__menu-btn",on:{"click":_vm.toggleAside}},[_c('dynamic-icon',{attrs:{"icon":"menu"}})],1)]),_vm._l((_vm.navigation),function(nav){return _c('AsideNavItem',{key:nav.id,attrs:{"nav":nav}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }